import React, { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  IconButton,
  Snackbar,
  Alert as MuiAlert
} from '@mui/material'
import {
  ConfirmationDialog,
  SnackBarHideDuration,
  SnackBarTransition,
  StyledTableCell,
  StyledTableRow
} from '../../utils/ui_utils'
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material'
import {
  useFetchAppFlavour,
  useCreateAppFlavour,
  useUpdateAppFlavour,
  useDeleteAppFlavour
} from '../../modules/appFlavours/appFlavourHooks'
import AppFlavourModal from './host/AppFlavourModal'

const AppFlavour = () => {
  const {
    getAppsForTerminal,
    getAppsForTerminalLoading,
    getAppsForTerminalError,
    getAppsForTerminalData
  } = useFetchAppFlavour()
  const {
    createAppFlavour,
    createAppFlavourLoading,
    createAppFlavourError,
    createAppFlavourData
  } = useCreateAppFlavour()
  const {
    updateAppFlavour,
    updateAppFlavourLoading,
    updateAppFlavourError,
    updateAppFlavourData
  } = useUpdateAppFlavour()
  const {
    deleteAppFlavour,
    deleteAppFlavourLoading,
    deleteAppFlavourError,
    deleteAppFlavourData
  } = useDeleteAppFlavour()

  const [applicationDrawerMode, setapplicationDrawerMode] = useState('edit')
  const [applicationDrawerVisible, setApplicationDrawerVisible] =
    useState(false)
  const [initialValues, setInitialValues] = useState({})
  const [deleteDialog, setDeleteDialog] = useState(false)
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)

  useEffect(() => {
    getAppsForTerminal()
  }, [])

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false)
  }

  const handleDeleteAction = () => {
    deleteAppFlavour(
      {
        _id: initialValues?._id,
        delete_status: true,
        app_package: initialValues?.app_package,
        flavor_name: initialValues?.flavor_name
      },
      (success, error, res) => {
        if (success) {
          getAppsForTerminal()
          setDeleteDialog(false)
          toastMessage('App Flavor Deleted Successfully', 'success')
        } else if (error) {
          console.log(error)
          toastMessage('App Flavor Deletion Failed', 'warning')
        }
      }
    )
  }

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  return (
    <>
      <Helmet title="App Flavours" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={5} md={6}>
          <Typography variant="h6" gutterBottom display="inline">
            App Flavour Management
          </Typography>
        </Grid>
        <Grid item>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              setapplicationDrawerMode('new')
              setApplicationDrawerVisible(true)
              setInitialValues({
                flavor_name: '',
                app_package: ''
              })
            }}
          >
            Create App Flavour
          </Button>
          <AppFlavourModal
            visible={applicationDrawerVisible}
            title={
              applicationDrawerMode == 'new'
                ? 'Add App Flavor'
                : 'Edit App Flavor'
            }
            initialValues={initialValues}
            okText={applicationDrawerMode == 'new' ? 'Create' : 'Update'}
            onSubmit={(value) => {
              let values = _.cloneDeep(value)
              if (applicationDrawerMode == 'new') {
                createAppFlavour(values, (success, error, res) => {
                  if (success) {
                    setApplicationDrawerVisible(false)
                    toastMessage('App Flavor Created Successfully', 'success')
                    getAppsForTerminal()
                  } else if (error) {
                    console.log(error)
                    toastMessage('App Flavor Creation Failed', 'warning')
                  }
                })
              } else {
                updateAppFlavour(values, (success, error, res) => {
                  if (success) {
                    setApplicationDrawerVisible(false)
                    toastMessage('App Flavor Updated Successfully', 'success')
                    getAppsForTerminal()
                  } else if (error) {
                    console.log(error)
                    toastMessage('App Flavor Updation Failed', 'warning')
                  }
                })
              }
            }}
            onClose={() => {
              setApplicationDrawerVisible(false)
            }}
            value={initialValues}
          />
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />
      <Grid container spacing={10} sx={{ paddingTop: 5 }}>
        <Grid item>
          <Card raised sx={{ borderRadius: 3 }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <TableContainer component={Card}>
                <Table size="small">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Flavor Name</StyledTableCell>
                      <StyledTableCell align="center">
                        App Package
                      </StyledTableCell>
                      <StyledTableCell align="center" colSpan={2}>
                        Actions
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {getAppsForTerminalData?.map((row, i) => (
                      <StyledTableRow
                        key={i}
                        hover
                        onClick={() => {
                          // console.log(row)
                        }}
                      >
                        <StyledTableCell
                          sx={{
                            paddingLeft: 4
                          }}
                        >
                          {row.flavor_name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row?.app_package}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <IconButton
                            size="small"
                            color="primary"
                            component="span"
                            onClick={() => {
                              setapplicationDrawerMode('edit')
                              setApplicationDrawerVisible(true)
                              setInitialValues({
                                flavor_name: row.flavor_name,
                                _id: row._id,
                                app_package: row.app_package,
                                delete_status: row.delete_status ?? false
                              })
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            sx={{ marginLeft: 5 }}
                            size="small"
                            color="primary"
                            component="span"
                            onClick={() => {
                              setInitialValues({
                                flavor_name: row.flavor_name,
                                _id: row._id,
                                app_package: row.app_package,
                                delete_status: false
                              })
                              setDeleteDialog(true)
                            }}
                          >
                            <DeleteIcon
                              style={{
                                color: 'red'
                              }}
                              fontSize="small"
                            />
                          </IconButton>{' '}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
            <ConfirmationDialog
              visibility={deleteDialog}
              title={'Delete'}
              message={
                'Do You want to delete this item - ' +
                initialValues?.flavor_name +
                ' ?'
              }
              okText={'Delete'}
              cancelText={'Cancel'}
              onOk={handleDeleteAction}
              onCancel={handleDeleteDialogClose}
              note={'Note: This action cannot be undone.'}
            />
            <Snackbar
              open={snackbar}
              autoHideDuration={SnackBarHideDuration}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              onClose={handleSnackbarClose}
              TransitionComponent={SnackBarTransition}
            >
              <Alert onClose={handleSnackbarClose} severity={severity}>
                {PopUpMessage}
              </Alert>
            </Snackbar>
          </Card>
        </Grid>
      </Grid>
    </>
  )
}

export default AppFlavour
